import styled from 'styled-components'

const handleHeadingLevel = (level: string) => {
    switch (level) {
        case 'sectionTitle':
            return '20px'
        case 'subSectionTitle':
            return '40px'
        case 'subSectionSectionTitle':
            return '60px'
        default:
            return 0
    }
}

export const ParagraphText = styled.p<{
    fontColor: string,
    fontStyle?: string,
    fontWeight?:  'normal' | 'bold' | string,
    headingLevel: string,
    textAlign: string
}>`
    font-family: Myriad Pro, sans-serif;
    font-size: 1.1rem;
    letter-spacing: .1rem;
    line-height: 1.7;
    margin: .5rem 0;
    margin-bottom: 2.5rem;
    color: ${({fontColor}) => fontColor ? fontColor : 'inherit'};
    font-style: ${({fontStyle}) => fontStyle ? fontStyle : 'inherit'};
    font-weight: ${({fontWeight}) => fontWeight ? fontWeight : 'inherit'};
    text-align: ${({textAlign}) => textAlign ? textAlign : 'inherit'};
    padding-left: ${({headingLevel}) => handleHeadingLevel(headingLevel)};
`
